module.exports = __webpack_public_path__ + "static/img/004txt-01.fe1be99d.png";